import * as yup from "yup";

export const FORM_VALIDATIONS = {
  REQUIRED: {
    required: {
      value: true,
      message: "Please enter value",
    },
  },
  REQUIRED_EMAIL: {
    required: {
      value: true,
      message: "Please enter email address",
    },
    pattern: {
      value:
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
      message: "Please enter valid email address",
    },
  },
  ONLY_ALPHABETS: {
    pattern: {
      value:
        // eslint-disable-next-line no-useless-escape
        /^[a-zA-Z ]*$/,
      message: "Only alphabets are allowed",
    },
  },
  REQUIRED_MOBILE: {
    required: {
      value: true,
      message: "Please enter value",
    },
    pattern: {
      value:
        // eslint-disable-next-line no-useless-escape
        /^[0-9]*$/i,
      message: "Please enter valid phone number",
    },
  },
  ONLY_NUMBER: {
    pattern: {
      value: /^[0-9]+$/,
      message: "Only numbers allowed for this field.",
    },
  },
  ONLY_NUMBER_FLOAT: {
    pattern: {
      value: /^[0-9.]+$/g,
      message: "Invalid value, please provide correct value.",
    },
  },
  LOGIN_PWD: {
    required: {
      value: true,
      message: "Please enter password",
    },
  },
  SIGNUP_PWD: {
    required: {
      value: true,
      message: "Please enter password",
    },
    minLength: {
      value: 8,
      message: "Password must be minimum 8 character long",
    },
    pattern: {
      value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])/,
      message:
        "The password should contain at least one uppercase letter, one lowercase letter, one special character, and one number.",
    },
  },
  REQUIRED_ZIPCODE: {
    required: {
      value: true,
      message: "Please enter value",
    },
    minLength: {
      value: 5,
      message: "Zipcode must be minimum 5 character long",
    },
    maxLength: {
      value: 6,
      message: "Zipcode can be maximum 6 character long",
    },
  },
  maxValidation: (length: number) => {
    return {
      max: {
        value: length,
        message: `Maximum allowed value is ${length}`,
      },
    };
  },
  minValidation: (length: number) => {
    return {
      min: {
        value: length,
        message: `Minimum allowed value is ${length}`,
      },
    };
  },
  maxLengthValidation: (length: number) => {
    return {
      maxLength: {
        value: length,
        message: `Maximum allowed length is ${length}`,
      },
    };
  },
  minLengthValidation: (length: number) => {
    return {
      minLength: {
        value: length,
        message: `Minimum allowed length is ${length}`,
      },
    };
  },
};

export const createAttachmentSchema: any = yup.object().shape({
  basic: yup.object().shape({
    attachment_id: yup
      .number()
      .required("Please select attachment category.")
      .typeError("Please select attachment category."),
    listing_name: yup
      .string()
      .trim()
      .min(10, "Listing name should be minimum 10 character.")
      .max(100, "Listing name should be maximum 10 character.")
      .required("Please enter listing name."),
    listing_description: yup
      .string()
      .trim()
      .min(25, "Listing description should be minimum 25 character.")
      .max(2000, "Listing description should be maximum 2000 character.")
      .required("Please enter listing description."),
  }),
  configs: yup.object().shape({
    emv: yup
      .number()
      .min(100, "EMV should be minimum 100.")
      .max(999999, "EMV should be maximum 9,99,999.")
      .required("Please enter EMV value.")
      .typeError("EMV must be a number"),
  }),
  features: yup.object().shape({
    capacity: yup
      .number()
      .min(1, "Capacity should be minimum 1.")
      .max(1000000, "Capacity should be maximum 1,00,0000.")
      .required("Please enter capacity.")
      .typeError("Capacity must be a number"),
    capacity_unit: yup.string().trim().required("Please select capacity unit."),
    attachment_type: yup
      .string()
      .trim()
      .required("Please select attachment type."),
  }),
});

export const createTractorSchema: any = yup.object().shape({
  basic: yup.object().shape({
    manufacturer_id: yup
      .number()
      .required("Please select make.")
      .typeError("Please select make."),
    manufacturer_model_id: yup
      .number()
      .required("Please select model.")
      .typeError("Please select model."),
    listing_name: yup
      .string()
      .trim()
      .min(10, "Listing name should be minimum 10 character.")
      .max(100, "Listing name should be maximum 10 character.")
      .required("Please enter listing name."),
    listing_description: yup
      .string()
      .trim()
      .min(25, "Listing description should be minimum 25 character.")
      .max(2000, "Listing description should be maximum 2000 character.")
      .required("Please enter listing description."),
  }),
  features: yup.object().shape({
    horse_power: yup
      .number()
      .min(1, "Horse power should be minimum 1.")
      .max(9999, "Horse power should be maximum 9999.")
      .required("Please enter horse power.")
      .typeError("Horse power must be a number"),
    year: yup
      .number()
      .required("Please select year.")
      .typeError("Please select year."),
  }),
  configs: yup.object().shape({
    emv: yup
      .number()
      .min(100, "EMV should be minimum 100.")
      .max(999999, "EMV should be maximum 9,99,999.")
      .required("Please enter EMV value.")
      .typeError("EMV must be a number"),
  }),
});

export const listingFeatureSchema: any = yup.object().shape({
  features: yup.object().shape({
    has_loader_bucker: yup.bool().required(),
    has_3point_lift: yup.bool().required(),
    has_pto: yup.bool().required(),
    has_cabin: yup.bool().required(),
    has_ac: yup.bool().required(),
    has_heater: yup.bool().required(),
    has_4wd: yup.bool().required(),
    has_power_steering: yup.bool().required(),
  }),
});

export const usageRatesSchema: any = yup.object().shape({
  configs: yup.object().shape({
    usage_type: yup.number().required("Please select usage type"),
    custom_hours: yup
      .number()
      .typeError("Hours should be less or equal to 24.")
      .when("usage_type", {
        is: 2,
        then: (schema) =>
          schema
            .min(1, "Hours should be minimum 1.")
            .max(24, "Hours should be maximum 24.")
            .required("Please provide hours.")
            .typeError("Hours should be between 1 to 24."),
        otherwise: (schema) => schema.notRequired(),
      }),
    custom_excess_hours_fee: yup.number().when("usage_type", {
      is: 2,
      then: (schema) =>
        schema
          .min(1, "Fees should be minimum 1.")
          .max(999999, "Fees should be maximum 9,99,999.")
          .required("Please provide excess hours fees.")
          .typeError("Exccess Fee should be between 1 to 99,99,999."),
      otherwise: () => yup.number().notRequired(),
    }),
    custom_min_rental_duration: yup
      .number()
      .min(1, "Rental duration should be minimum 1.")
      .max(99, "Rental duration should be maximum 99.")
      .required("Please provide minimum rental duration.")
      .typeError("Rental duration should be between 1 to 99."),
  }),
});

export const pricingSchema: any = yup.object().shape({
  basic: yup.object().shape({
    price: yup
      .number()
      .min(1, "Price should be minimum 1.")
      .max(999999, "Price should be maximum 9,99,999.")
      .required("Please provide price.")
      .typeError("Price should be number only."),
  }),
});

export const addressSchema: any = yup.object().shape({
  addressLine1: yup.string().required("Please add listing address."),
  addressLine2: yup.string(),
  city: yup.string(),
  state: yup.string(),
  zipcode: yup.string(),
  latitude: yup.number(),
  longitude: yup.number(),
  addressType: yup.number(),
  country: yup.string(),
});

export const approvalPolicySchema: any = yup.object().shape({
  approval_policy_type: yup
    .number()
    .required("Please select the approval policy"),
  offer_delv_pickup: yup.number().required("Please select any one option."),
  addressLine1: yup.string().required("Please add listing address."),
  min_delv_pickup_fees: yup.number().when("offer_delv_pickup", {
    is: 1,
    then: (schema) =>
      schema
        .min(100, "Pickup fee should be minimum 100")
        .max(99999, "Pickup fee should be maximum 99,999")
        .required()
        .typeError("Pickup fee should be between 100 to 9,99,999"),
    otherwise: () => yup.number().notRequired(),
  }),
  max_delv_distance: yup.number().when("offer_delv_pickup", {
    is: 1,
    then: (schema) =>
      schema
        .min(1, "Delivery distance should be minimum 1.")
        .max(999, "Delivery distance should be maximum 999.")
        .required()
        .typeError("Delivery distance should be minimum 1."),
    otherwise: () => yup.number().notRequired(),
  }),
  offer_operator_service: yup
    .number()
    .required("Please select any one option."),
  min_operator_fee: yup.number().when("offer_operator_service", {
    is: 1,
    then: (schema) =>
      schema
        .min(10, "Operator fee should be minimum 10.")
        .max(999999, "Operator fee should be maximum 9,99,999.")
        .required()
        .typeError("Min operator fee should be number."),

    otherwise: () => yup.number().notRequired(),
  }),
  max_operator_fee: yup.number().when("offer_operator_service", {
    is: 1,
    then: (schema) =>
      schema
        .min(10, "Operator fee should be minimum 10.")
        .max(1000, "Operator fee should be maximum 1000.")
        .moreThan(
          yup.ref("min_operator_fee"),
          "Max operator fee should be greater than min operator fees."
        )
        .required()
        .typeError("Max operator fee should be number."),
    otherwise: () => yup.number().notRequired(),
  }),
  security_deposit: yup
    .number()
    .min(1, "Security deposit should be minimum $1.")
    .max(99, "Security depost should be maximum $99.")
    .required()
    .typeError("Security deposit should be between $1 to $99."),
});

export const changePasswordSchema: any = yup.object().shape({
  new_password: yup
    .string()
    .trim()
    .notOneOf(
      [yup.ref("current_password")],
      "New password must be different from old password"
    )
    .required("Please enter your password")
    .min(8, "Password should be minimum 8.")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])/,
      "Password should contain at least one uppercase letter, one lowercase letter, one special character, and one number."
    ),

  current_password: yup.string().trim().required("Please enter your password"),
  confirm_new_password: yup
    .string()
    .trim()
    .required("Please enter your password")
    .oneOf([yup.ref("new_password"), ""], "Passwords must match"),
});

export const signUpSchema: any = yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(4, "Name should be minimum 4 characters.")
    .max(25, "Name should be maximum 25 characters.")
    .matches(/^[a-zA-Z ]*$/, "Name should allow only alphabets.")
    .required("Please enter name."),
  email: yup
    .string()
    .trim()
    .matches(
      /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\]\\.,;:\s@\\"]+\.)+[^<>()[\]\\.,;:\s@\\"]{2,})$/i,
      "Please enter valid email address."
    )
    .required("Please enter email"),
  password: yup
    .string()
    .trim()
    .required("Please enter your password")
    .min(8, "Password should be minimum 8.")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])/,
      "Password should contain at least one uppercase letter, one lowercase letter, one special character, and one number."
    ),
  confirmPassword: yup
    .string()
    .required("Please confirm your password")
    .oneOf(
      [yup.ref("password")],
      "Confirm password should be same as your Password."
    ),
  tandc: yup
    .bool()
    .oneOf([true], "Please read & accept the terms and policies."),
});

export const listEquipmentSchema: any = yup.object().shape({
  id: yup.number(),
  equipmentType: yup.number().required(),
  listing_name: yup
    .string()
    .trim()
    .min(5, "Listing name should be minimum 5 character.")
    .max(20, "Listing name should be maximum 20 character.")
    .required("Please enter listing name."),
  listing_description: yup
    .string()
    .trim()
    .min(25, "Listing description should be minimum 25 character.")
    .max(2000, "Listing description should be maximum 2000 character.")
    .required("Please enter listing description."),
  manufacturer_id: yup.number().when("equipmentType", {
    is: 1,
    then: (schema) =>
      schema.required("Please select make.").typeError("Please select make."),
    otherwise: (schema) => schema.notRequired(),
  }),

  manufacturer_model_id: yup.number().when("equipmentType", {
    is: 1,
    then: (schema) =>
      schema.required("Please select model.").typeError("Please select model."),
    otherwise: (schema) => schema.notRequired(),
  }),
  attachment_id: yup.number().when("equipmentType", {
    is: 2,
    then: (schema) =>
      schema
        .required("Please select attachment category.")
        .typeError("Please select attachment category."),
    otherwise: (schema) => schema.notRequired(),
  }),

  attachment_type: yup
    .string()
    .trim()
    .when("equipmentType", {
      is: 2,
      then: (schema) => schema.required("Please select attachment type."),
      otherwise: (schema) => schema.notRequired(),
    }),
  price: yup
    .number()
    .min(1, "Price should be minimum 1.")
    .max(999999, "Price should be maximum 9,99,999.")
    .required("Please provide price.")
    .typeError("Price should be number only."),
  price_unit: yup.string(),
  horse_power: yup.number().when("equipmentType", {
    is: 1,
    then: (schema) =>
      schema
        .min(1, "Horse power should be minimum 1.")
        .max(999, "Horse power should be maximum 999.")
        .required("Please enter horse power.")
        .typeError("Horse power must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),
  year: yup.number().when("equipmentType", {
    is: 1,
    then: (schema) =>
      schema.required("Please select year.").typeError("Please select year."),
    otherwise: (schema) => schema.notRequired(),
  }),

  emv: yup
    .number()
    .min(100, "EMV should be minimum 100.")
    .max(999999, "EMV should be maximum 9,99,999.")
    .required("Please enter EMV value.")
    .typeError("EMV must be a number"),

  capacity: yup.number().when("equipmentType", {
    is: 2,
    then: (schema) =>
      schema
        .min(1, "Capacity should be minimum 1.")
        .max(1000000, "Capacity should be maximum 1,00,0000.")
        .required("Please enter capacity.")
        .typeError("Capacity must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),
  capacity_unit: yup
    .string()
    .trim()
    .when("equipmentType", {
      is: 2,
      then: (schema) => schema.required("Please select capacity unit."),
      otherwise: (schema) => schema.notRequired(),
    }),

  has_loader_bucker: yup.bool().required(),
  has_3point_lift: yup.bool().required(),
  has_pto: yup.bool().required(),
  has_cabin: yup.bool().required(),
  has_ac: yup.bool().required(),
  has_heater: yup.bool().required(),
  has_4wd: yup.bool().required(),
  has_power_steering: yup.bool().required(),

  images: yup
    .array()
    .min(2, "At least 2 images are required")
    .max(6, "Maximum of 6 images allowed")
    .required("Images are required"),

  usage_type: yup.number().required("Please select usage type"),
  custom_hours: yup
    .number()
    .typeError("Hours should be less or equal to 24.")
    .when("usage_type", {
      is: 2,
      then: (schema) =>
        schema
          .min(1, "Hours should be minimum 1.")
          .max(24, "Hours should be maximum 24.")
          .required("Please provide hours.")
          .typeError("Hours should be between 1 to 24."),
      otherwise: (schema) => schema.notRequired(),
    }),
  custom_excess_hours_fee: yup.number().when("usage_type", {
    is: 2,
    then: (schema) =>
      schema
        .min(1, "Fees should be minimum 1.")
        .max(999999, "Fees should be maximum 9,99,999.")
        .required("Please provide excess hours fees.")
        .typeError("Exccess Fee should be between 1 to 99,99,999."),
    otherwise: () => yup.number().notRequired(),
  }),
  custom_min_rental_duration: yup
    .number()
    .min(1, "Rental duration should be minimum 1.")
    .max(99, "Rental duration should be maximum 99.")
    .required("Please provide minimum rental duration.")
    .typeError("Rental duration should be between 1 to 99."),
  // .when("usage_type", {
  //   is: 2,
  //   then: (schema) =>
  //     schema
  //       .min(1, "Rental duration should be minimum 1.")
  //       .max(99, "Rental duration should be maximum 99.")
  //       .required("Please provide minimum rental duration.")
  //       .typeError("Rental duration should be between 1 to 99."),
  //   otherwise: () => yup.number().notRequired(),
  // }),

  custom_hours_unit: yup.string(),
  custom_excess_hours_fee_unit: yup.string(),
});
